import React, {useEffect} from "react";
import {connect} from "react-redux";

import {useHistory} from "react-router-dom";

import Router from "router/router";
import MenuType from "enum/MenuType";
import CategoryType from "enum/CategoryType";
import * as AppAction from "store/app/action";
import {observer} from "mobx-react";
import useMyStores from "@/hooks/useMyStores";

function RouterListener({appAction}) {
    const history = useHistory();

    const { menu, home} = useMyStores()

    useEffect(() => {
        /**
         * 监听路由变化
         */
        history.listen((route) => {
            window.scrollTo(0, 0);
            const {pathname} = route;
            /**
             * ai-robot
             */
            if (pathname === Router.Home.path || pathname === Router.Index.path) {
                if (!window.AiRobot) {
                    const clock = setInterval(() => {
                        if (window.AiRobot) {
                            clearInterval(clock);
                            window.AiRobot.add();
                        }
                    }, 10);
                } else {
                    window.AiRobot.add();
                }
            } else {
                if (!window.AiRobot) {
                    const clock = setInterval(() => {
                        if (window.AiRobot) {
                            clearInterval(clock);
                            window.AiRobot.remove();
                        }
                    }, 10);
                } else {
                    window.AiRobot.remove();
                }
            }

            /**
             * menu组件里面 商品类别 的变化
             */
            if (pathname.indexOf(Router.News.realPath) !== -1) {
                appAction.setCategoryType(CategoryType.NEWS_CATEGORY.value);
            } else if (
                pathname === Router.Home.path ||
                pathname === Router.Index.path
            ) {
                appAction.setCategoryType(CategoryType.GOODS_CATEGORY.value);
            } else if (pathname === Router.Search.path) {
                appAction.setCategoryType(CategoryType.SEARCH_GOODS_CATEGORY.value);
            } else {
                appAction.setCategoryType(CategoryType.NONE.value);
            }
            /**
             * Menu组件的变化
             */
            if (pathname.indexOf(Router.Shop.realPath) !== -1) {
                appAction.setMenuType(MenuType.SHOP);
            } else if (
                pathname === Router.SecKill.path ||
                pathname === Router.User.path ||
                pathname === Router.Cart.path ||
                pathname.indexOf(Router.Merchant.path) !== -1 ||
                pathname === Router.Help.path
            ) {
                appAction.setMenuType(MenuType.NONE);
            } else {
                appAction.setMenuType(MenuType.GOODS);
            }
            /**
             * home top advertisement 组件的显示与隐藏
             */
            if (pathname === Router.Home.path || pathname === Router.Index.path) {
                home.canShowTopAdvertisement = true;
            } else {
                home.canShowTopAdvertisement = false
            }

            /**
             * menu的适应布局
             */
            if (pathname === Router.Home.path || pathname === Router.Index.path) {
                menu.is1200 = true;
            } else {
                menu.is1200 = false;
            }
        });
    }, []);

    return <div></div>;
}

export default connect(
    (state) => {
        const {app} = state;

        return {app};
    },
    (f) => ({
        appAction: {
            setCategoryType() {
                f(AppAction.setCategoryType(...arguments));
            },
            setMenuType() {
                f(AppAction.setMenuType(...arguments));
            },
        }
    })
)(observer(RouterListener));
